export { PortfolioHoldingsTableWidget } from './PortfolioHoldingsTableWidget';
